"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getDedupedAllCollectionsResults = exports.getCollectionSearchQuery = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = _interopRequireDefault(require("immutable"));

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var _once = _interopRequireDefault(require("hs-lodash/once"));

var _constants = require("../constants");

var FilterKey = _interopRequireWildcard(require("../constants/search/FilterKey"));

var SortField = _interopRequireWildcard(require("../constants/search/SortField"));

var StorefrontCollection = _interopRequireWildcard(require("../constants/StorefrontCollection"));

var _storefrontCollectionOrder = _interopRequireDefault(require("../constants/storefrontCollectionOrder"));

var _SearchResult = _interopRequireDefault(require("./SearchResult"));

var _StorefrontFilters = _interopRequireDefault(require("./StorefrontFilters"));

var SEARCH_LENGTH = 3;
var RANDOM_SEARCH_LENGTH = 27;

var EMPTY_MAP = _immutable.default.Map();

var EMPTY_SET = _immutable.default.Set();

var collectionsOrder = _immutable.default.OrderedSet(_storefrontCollectionOrder.default);

var collectionsOrderIndexedSeq = collectionsOrder.toIndexedSeq();
var collectionsOrderedMap = collectionsOrder.toOrderedMap();
var getSearchQuery = (0, _once.default)(function () {
  return collectionsOrder.map(function (collection) {
    var filters = new _StorefrontFilters.default((0, _defineProperty2.default)({}, FilterKey.COLLECTION, collection));
    var useRandom = ![StorefrontCollection.POPULAR, StorefrontCollection.NEW].includes(collection);
    var query = filters.toSearchQuery({
      length: useRandom ? RANDOM_SEARCH_LENGTH : SEARCH_LENGTH
    });

    if (collection === StorefrontCollection.POPULAR) {
      query[FilterKey.SORT_FIELD] = SortField.HUB_INSTALLS;
    } else if (collection === StorefrontCollection.NEW) {
      query[FilterKey.SORT_FIELD] = SortField.FIRST_PUBLISHED;
    } else {
      query[FilterKey.SORT_FIELD] = SortField.RANDOM;
    }

    return query;
  }).toArray();
});
var getSearchQueryMap = (0, _once.default)(function () {
  return getSearchQuery().reduce(function (acc, current, index) {
    return acc.set(collectionsOrderIndexedSeq.get(index), current);
  }, EMPTY_MAP);
});
var getCollectionSearchQuery = (0, _memoize.default)(function (collection) {
  return getSearchQueryMap().get(collection);
});
exports.getCollectionSearchQuery = getCollectionSearchQuery;

var getDedupedAllCollectionsResults = function getDedupedAllCollectionsResults(results) {
  var resultIds = EMPTY_SET;
  return results.withMutations(function (mutableResults) {
    collectionsOrderIndexedSeq.forEach(function (collection) {
      var collectionResult = results.get(collection);
      var collectionResultItems = collectionResult.items;

      if (collectionResultItems.size > _constants.ALL_COLLECTIONS_LENGTH) {
        collectionResultItems = collectionResultItems.filter(function (_ref2) {
          var id = _ref2.id;
          return !resultIds.includes(id);
        }).take(_constants.ALL_COLLECTIONS_LENGTH);
        mutableResults.setIn([collection, 'items'], collectionResultItems);
      }

      resultIds = resultIds.concat(collectionResultItems.map(function (_ref3) {
        var id = _ref3.id;
        return id;
      }));
    });
  });
};

exports.getDedupedAllCollectionsResults = getDedupedAllCollectionsResults;
var defaults = collectionsOrder.reduce(function (final, collection) {
  return (0, _extends4.default)({}, final, (0, _defineProperty2.default)({}, collection, new _SearchResult.default()));
}, {});

var AllCollectionsResults = /*#__PURE__*/function (_Immutable$Record) {
  (0, _inherits2.default)(AllCollectionsResults, _Immutable$Record);

  function AllCollectionsResults() {
    (0, _classCallCheck2.default)(this, AllCollectionsResults);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AllCollectionsResults).apply(this, arguments));
  }

  (0, _createClass2.default)(AllCollectionsResults, [{
    key: "toOrderedMap",
    value: function toOrderedMap() {
      var _this = this;

      return collectionsOrderedMap.map(function (collection) {
        return _this.get(collection);
      });
    }
  }], [{
    key: "from",
    value: function from(resultsArray) {
      return new AllCollectionsResults(resultsArray.reduce(function (final, result, index) {
        var collection = collectionsOrderIndexedSeq.get(index);
        return (0, _extends4.default)({}, final, (0, _defineProperty2.default)({}, collection, new _SearchResult.default(result)));
      }, {}));
    }
  }]);
  return AllCollectionsResults;
}(_immutable.default.Record(defaults));

var _default = AllCollectionsResults;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./js/records/AllCollectionsResults.js
// module id = 320
// module chunks = 209 210 211 212 213